module.exports = __webpack_public_path__ + "static/phone-demo-short-36d3ca85c72e84b458176c6c81480b4a.png";